export class RuleValidationResult {
	isValid: boolean = true;
	errorMessage: string = '';
	// Confirm - whether to display the error as a confirmation prompt.
	confirm: boolean = false;
}
